export enum ModalErrorTimer {
  AUTO_HIDE_DURATION_DELAY = 6000,
  DELETE_ERROR_DELAY = 1500,
}
